import React from 'react'
import { Nav } from 'react-bootstrap'
import { TabHeaderContainer } from './headers.styles'

export interface TabItem {
  key: string
  label: string
  icon?: React.ReactNode
  disabled?: boolean
}

export interface TabHeaderProps {
  tabs: TabItem[]
  activeKey: string
  onSelect: (key: string | null) => void
  className?: string
}

const TabHeader: React.FC<TabHeaderProps> = ({ tabs, activeKey, onSelect, className }) => {
  return (
    <TabHeaderContainer className={className}>
      <Nav variant="tabs" activeKey={activeKey} onSelect={onSelect}>
        {tabs.map((tab) => (
          <Nav.Item key={tab.key}>
            <Nav.Link
              eventKey={tab.key}
              disabled={tab.disabled}
              className={tab.disabled ? 'disabled' : ''}
            >
              {tab.icon && <span className="tab-icon">{tab.icon}</span>}
              {tab.label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </TabHeaderContainer>
  )
}

export default TabHeader
